import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Chip } from "@mui/material";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import MainApi from "../../../../../../services/mainApi.service";
import { useCallback, useMemo, useState } from "react";
import { ITicketAutomationReceivedCustomMessage } from "../../../../../../models/automation-received-custom-message";
import AutomationReceivedCustomMessage from "./AutomationReceivedCustomMessageForm/AutomationReceivedCustomMessage";

const TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedCustomMessage/";
const ticketAutomationReceivedCustomMessageService =
  new MainApi<ITicketAutomationReceivedCustomMessage>(
    TICKET_AUTOMATION_RECEIVED_SLOT_ROUTE
  );

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedCustomMessage.";

function joinExternalNames(
  items?: Array<{ externalName?: string | null }> | null
): string {
  if (!items?.length) return "-";
  const seen = new Set<string>();
  const out: string[] = [];
  for (const it of items) {
    const name = (it?.externalName ?? "").trim();
    if (!name) continue;
    const key = name.toLocaleLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(name);
  }
  return out.length ? out.join("; ") : "-";
}

const AutomationReceivedCustomMessagePage = ({
  automationCode,
}: {
  automationCode?: string;
}) => {
  const { t } = useTranslation();

  const { id: ticketAutomationReceivedRuleId } = useParams();

  const [timeRuleForm, setTimeRuleForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const columns: GridColDef<ITicketAutomationReceivedCustomMessage>[] = [
    {
      field: "ticketAutomationReceivedCaleExamGroupings",
      headerName:
        t(translationPath + "ticketAutomationReceivedCaleExamGroupings") ||
        "Agrupamento da Agenda",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const text = joinExternalNames(params.value);
        return <OverflowTooltip text={text} tooltip={text} />;
      },
    },
    {
      field: "ticketAutomationReceivedCustomMessageCalendars",
      headerName:
        t(translationPath + "ticketAutomationReceivedCustomMessageCalendars") ||
        "Agendas",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const text = joinExternalNames(params.value);
        return <OverflowTooltip text={text} tooltip={text} />;
      },
    },
    {
      field: "message",
      headerName: t(translationPath + "message") || "Message",
    },
  ];

  const handleAdd = () => {
    setTimeRuleForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<ITicketAutomationReceivedCustomMessage>
  ) => {
    if (!params.row) return;
    setTimeRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTimeRuleForm(false);
  }, []);
  const props = useMemo(() => {
    return {
      TicketAutomationReceivedRuleId: ticketAutomationReceivedRuleId,
    };
  }, []);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {timeRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <AutomationReceivedCustomMessage
            id={selectedId}
            ticketAutomationReceivedRuleId={ticketAutomationReceivedRuleId}
            onBackButton={handleBack}
            automationCode={automationCode}
          />
        </Box>
      )}
      {!timeRuleForm && (
        <Box height={600}>
          <Table<ITicketAutomationReceivedCustomMessage>
            showDefaultMacroFilters={false}
            service={ticketAutomationReceivedCustomMessageService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add_custom_message") || "Add Custom Message"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default AutomationReceivedCustomMessagePage;
